export const LanguageCodeEnum = Object.freeze({
    vi: "vi",
    en: "en",
});